<app-header></app-header>

<ion-content scrollbar>
  <app-breadcrumb></app-breadcrumb>
  <ng-container *ngIf="!isError; else HTTPError">
    <ion-grid>
      <ion-row class="margin-minus-20-mobile">
        <ion-col size="12" size-xl="6" offset-xl="3">
          <app-card [title]="headerInit.title">
            <form [formGroup]="form" class="w-100">
              <app-loading-sti *ngIf="loading"></app-loading-sti>
              <ng-container *ngIf="!loading">
                <div
                  *ngIf="!hideBuildingDropdown"
                  class="control-display"
                  [ngClass]="{'control-display--invalid': form.get('building').hasError('required') && (form.get('building').touched || validationError)}"
                >
                  <ion-label>{{'COMMUNITY.BUILDING' | translate}}*</ion-label>
                  <app-select-dropdown
                    [isDisabled]="idCommunity !== 0"
                    formControlName="building"
                    [data]="buildingServ.buildings"
                    (changeValueEvent)="buildingChange($event)"
                    (touchEvent)="onSelectTouched('building')"
                    [value]="currentBuilding"
                  >
                  </app-select-dropdown>
                </div>

                <ion-label
                  *ngIf="form.get('building').hasError('required') && (form.get('building').touched || validationError)"
                  color="danger"
                  class="font-size__16"
                >
                  {{'COMMUNITY.REQUIRED_VALIDATION' | translate }}
                </ion-label>

                <app-input
                  type="input"
                  [form]="form"
                  formControlName="title"
                  label="COMMUNITY.TITLE"
                  placeholder="{{ 'COMMUNITY.ENTER_TITLE' | translate }}"
                  (touchEvent)="onSelectTouched('title')"
                  [submittedError]="validationError"
                ></app-input>

                <ion-item lines="none" class="input overflow-auto">
                  <div
                    class="control-display"
                    [ngClass]="{'control-display--invalid': (form.get('description').hasError('required') || form.get('description').hasError('onlySpaces')) && (form.get('description').touched || validationError)}"
                  >
                    <ion-label
                      >{{'COMMUNITY.DESCRIPTION' | translate}}</ion-label
                    >

                    <app-loading-sti
                      *ngIf="!showEditor"
                      class="edit-community__editor-loader"
                    ></app-loading-sti>
                    <div *appHasRole="['community.auto_generate_description']">
                      <ion-button
                        *ngIf="loadTinyMce"
                        class="edit-community__editor-button"
                        fill="outline"
                        size="small"
                        (click)="generateAiContent()"
                      >
                        {{ 'COMMUNITY.GENERATE_DESCRIPTION' | translate }}
                      </ion-button>
                    </div>
                    <div class="edit-community__editor-container">
                      <ng-container>
                        <editor
                          *ngIf="loadTinyMce"
                          [ngClass]="{'height-0': !showEditor}"
                          apiKey="j3ckhul0o9hbg0zj9xhph1utn78ibbzmyno6qxuafa5mih89"
                          class="edit-community__editor"
                          formControlName="description"
                          [init]="textEditorConfig"
                          (onInit)="onTinyInit()"
                          (onGetContent)="onGetContent($event)"
                          (onLoadContent)="onGetContent($event)"
                        >
                        </editor>
                      </ng-container>
                    </div>
                  </div>
                </ion-item>

                <ion-label
                  *ngIf="(form.get('description').hasError('tinyInvalid')) && (form.get('description').touched || validationError)"
                  color="danger"
                  class="font-size__16"
                >
                  {{'COMMUNITY.REQUIRED_VALIDATION' | translate }}
                </ion-label>
                <ion-label
                  *ngIf="form.get('description').hasError('maxlength') && (form.get('description').touched || validationError)"
                  color="danger"
                  class="font-size__16"
                >
                  {{'COMMUNITY.MAX_LENGTH' | translate }}
                </ion-label>

                <ion-item lines="none" class="input" *ngIf="idCommunity === 0">
                  <div class="control-display">
                    <ion-label>
                      {{ "COMMUNITY.PUBLISH_DATE" | translate }}</ion-label
                    >
                    <app-date-time-picker
                      [value]="startDate"
                      [min]="startDate"
                      placeholder='{{ "COMMUNITY.PUBLISH_DATE" | translate }}'
                      (afterPickerClosed)="publicationDate($event)"
                    ></app-date-time-picker>
                  </div>
                </ion-item>
                <!-- EVENT: -->
                <div *ngIf="(typeId === type.Events) || (typeId === type.Agenda)">
                  <ion-item lines="none" class="input">
                    <div class="control-display">
                      <ion-label
                        >{{'COMMUNITY.START_TIME' | translate }}*</ion-label
                      >
                      <app-date-time-picker
                        [pickerType]="(typeId === type.Events) ? 'calendar' : 'both'"
                        [value]="startDate"
                        placeholder="{{'COMMUNITY.START_TIME' | translate }}"
                        (afterPickerClosed)="dateTimeChange($event, 'start')"
                      ></app-date-time-picker>
                    </div>
                  </ion-item>

                  <ion-label
                    *ngIf="form.get('startTime').hasError('required') && (form.get('startTime').touched || validationError)"
                    color="danger"
                    class="font-size__16"
                  >
                    {{'COMMUNITY.REQUIRED_VALIDATION' | translate }}
                  </ion-label>

                  <ion-item lines="none" class="input">
                    <div class="control-display">
                      <ion-label
                        >{{'COMMUNITY.END_TIME' | translate }}*</ion-label
                      >

                      <app-date-time-picker
                        [pickerType]="(typeId === type.Events) ? 'calendar' : 'both'"
                        [value]="endDate"
                        placeholder="{{'COMMUNITY.END_TIME' | translate }}"
                        (afterPickerClosed)="dateTimeChange($event, 'end')"
                      ></app-date-time-picker>
                    </div>
                  </ion-item>

                  <ion-label
                    *ngIf="form.get('endTime').hasError('required') && (form.get('endTime').touched || validationError)"
                    color="danger"
                    class="font-size__16"
                  >
                    {{'COMMUNITY.REQUIRED_VALIDATION' | translate }}
                  </ion-label>

                  <ion-label
                    color="danger"
                    *ngIf="
                      (form.get('startTime').touched && form.get('endTime').touched) &&
                      form.hasError('startDateBigger')
                    "
                    class="font-size__16"
                  >
                    {{ "SPACE.START_LATER_THAN_END" | translate }}
                  </ion-label>

                  <app-input
                    type="input"
                    [form]="form"
                    formControlName="localization"
                    label="COMMUNITY.LOCALIZATION"
                    [submittedError]="validationError"
                  ></app-input>
                </div>

                <!-- END EVENT -->
                <ng-container *appHasRole="['community.admin']">
                  <app-checkbox
                    *ngIf="idCommunity === 0"
                    [form]="form"
                    [slot]="'start'"
                    [checked]="'false'"
                    formControlName="sendNotification"
                    label="COMMUNITY.SEND_NOTIFICATION"
                  ></app-checkbox>
                </ng-container>

                <ion-item lines="none" class="input">
                  <div class="control-display">
                    <app-upload-attachment
                      [attachment]="communityServ.community.image"
                      (attachmentUploaded)="imageUploaded($event)"
                      (attachmentRemoved)="imageRemoved($event)"
                      uploadAttachmentButtonText="{{'COMMUNITY.ADD_MAIN_PICTURE' | translate}}"
                      changeAttachmentButtonText="{{'COMMUNITY.EDIT_MAIN_PICTURE' | translate}}"
                    >
                    </app-upload-attachment>
                  </div>
                </ion-item>
                <ion-item
                  lines="none"
                  class="input"
                  *ngIf="idCommunity == 0 && communityServ.community.additionalImages"
                >
                  <div class="control-display">
                    <app-upload-attachment
                      [multiple]="true"
                      [attachment]="communityServ.community.additionalImages ? communityServ.community.additionalImages : []"
                      (attachmentUploaded)="additionalImageUploaded($event)"
                      (attachmentRemoved)="additionalImageRemoved($event)"
                      [readonly]="multipleFilesReadOnly"
                      uploadAttachmentButtonText="{{'COMMUNITY.ADD_ADDITIONAL_PICTURES' | translate}}"
                      changeAttachmentButtonText="{{'COMMUNITY.EDIT_ADDITIONAL_PICTURES' | translate}}"
                    >
                    </app-upload-attachment>
                  </div>
                </ion-item>
                <ion-label
                  *ngIf="form.get('itemImage').hasError('fileMaxSize') && (form.get('itemImage').touched || validationError)"
                  color="danger"
                  class="font-size__16"
                >
                  {{"MARKET.MAX_SIZE"|translate}}
                </ion-label>
                <ion-label
                  *ngIf="form.get('itemImage').hasError('fileFormat') && (form.get('itemImage').touched || validationError)"
                  color="danger"
                  class="font-size__16"
                >
                  <div>
                    {{ "FILE_TYPE_VALIDATION_1" | translate }}
                    "{{form.get('itemImage').errors.fileFormat.actualFormat}}".
                    {{ "FILE_TYPE_VALIDATION_2" | translate }}
                  </div>
                </ion-label>
                <ion-item class="input" lines="none">
                  <ion-button
                    *ngIf="idCommunity != 0 && !p.renderMobile"
                    class="button-margin-top-md"
                    slot="start"
                    fill="outline"
                    size="medium"
                    color="primary"
                    (click)="delete()"
                    >{{ 'DELETE' | translate}}
                  </ion-button>

                  <ion-button
                    class="button-margin-top-md"
                    (click)="Save()"
                    size="medium"
                    slot="end"
                    [disabled]="disableSaveButton"
                  >
                    <ng-container *ngIf="!disableSaveButton"
                      >{{'SAVE' | translate}}</ng-container
                    >
                    <ng-container *ngIf="disableSaveButton"
                      >{{'SAVING' | translate}}</ng-container
                    >
                  </ion-button>
                </ion-item>
              </ng-container>
            </form>
          </app-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
  <ng-template #HTTPError>
    <app-api-not-found
      name="COMMUNITY.POST"
      link="app/community"
      returnText="COMMUNITY.RETURN_TO_COMMUNITY"
      [status]="errorStatus"
    >
    </app-api-not-found>
  </ng-template>
</ion-content>
